module.exports = __webpack_public_path__ + "static/media/logo-root.54c16678.svg";